import { IVendorStatus } from '../interface/IVendorStatus';

export enum ListingSkuStatusNamesEnum {
  active = 'Active',
  pending = 'Pending',
  inactive = 'Inactive',
  soldOut = 'Sold Out',
  paused = 'Paused',
  removed = 'Removed',
  archived = 'Archived'
}


// These values mirror the API's SkuStatus enum positionally and are posted back as
// the grid filter and as the export options, so pending is APPENDED (7) to match the member added
// on the server. Its position here is the wire value, not the order it is displayed in - the
// Product Listings strip shows it between Active and Inactive, ordered by orderStatusTabs().
export enum ListingSkuStatusValuesEnum {
  all,
  active,
  inactive,
  soldOut,
  paused,
  removed,
  archived,
  pending
}

/**
 * Display order for the listing statuses. StatusCounts returns them in the API's SkuStatus order,
 * which puts Pending last because that enum has to stay positionally stable - its ordinal is what
 * the grid filter and the export options post back. Both places that render the statuses, the
 * Product Listings tab strip and the dashboard's Listing Details boxes, show Pending between
 * Active and Inactive, so the order is rebuilt here once for both. Every other status keeps the
 * order the API sent, and a response without Pending is returned untouched.
 */
export function orderListingStatusesForDisplay(statuses: IVendorStatus[]): IVendorStatus[] {
  if (!statuses) { return statuses; }

  const pending = statuses.find(s => s.value === ListingSkuStatusValuesEnum.pending);
  if (!pending) { return statuses; }

  const ordered = statuses.filter(s => s.value !== ListingSkuStatusValuesEnum.pending);
  const activeIndex = ordered.findIndex(s => s.value === ListingSkuStatusValuesEnum.active);
  ordered.splice(activeIndex < 0 ? ordered.length : activeIndex + 1, 0, pending);

  return ordered;
}
